import { render, staticRenderFns } from "./devicePagesHeader.vue?vue&type=template&id=34797094&lang=pug"
import script from "./devicePagesHeader.vue?vue&type=script&lang=js"
export * from "./devicePagesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports